<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="Course1">
        <!-- 导航 -->
        <div class="nav">
          <div class="left">
            <div class="jingpin">精品好课</div>
            <ul>
              <li
                v-for="(tab,index) in tabs"
                :key="index"
                @click="toggle(index,tab.id)"
                :class="{active:active==index}"
              >{{tab.name}}</li>
            </ul>
          </div>
          <div class="more" @click="goedetails">查看更多</div>
        </div>
      </div>
      <div>
        <div class="cont">
          <div class="list" @click="godetails(list.id)" v-for="(list,index) in lists" :key="index">
            <div class="list-cont">
              <div>
                 <img :src="list.image" alt />
              </div>
              <div class="right">
                  <div class="name">{{list.name}}</div>
                  <p class="price" v-if="list.members_free==1">VIP免费</p>
                  <p class="price" v-if="list.price!=0.00&&list.members_free==0">¥{{list.price}}</p>
                  <p class="price" v-if="list.price==0.00&&list.members_free!=1">免费</p>
              </div>
            </div>
          </div>
          <div class="more">更多推荐</div>
          <div class="list" @click="godetails(g_list.id)" v-for="(g_list,index) in g_lists" :key="'info2-'+index">
            <div class="list-cont" >
              <div>
                 <img :src="g_list.image" alt />
              </div>
             
              <div class="right">
                <div class="name">{{g_list.name}}</div>
                  <p class="price" v-if="g_list.members_free==1">VIP免费</p>
                  <p class="price" v-if="g_list.price!=0.00&&g_list.members_free==0">¥{{g_list.price}}</p>
                  <p class="price" v-if="g_list.price==0.00&&g_list.members_free!=1">免费</p>
              </div>
            </div>
          </div>
          <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout=" prev, pager, next"
                :total="totalNum"
              ></el-pagination>
            </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";

export default {
  name: "",
  data() {
    return {
      active: 0,
      currentView: "",
      tabs: [],
      lists:[],
      g_lists:[],
      currentPage: 1, //默认显示第一页
      pageSize: 8, //默认每页显示条
      totalNum: 0, //总页数
    };
  },
  methods: {
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.appraisal_list();
    },
     // 测评分类
    async appraisal_type_list() {
      await this.$service.home
        .appraisal_type_list({})
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.tabs = res.data.content;
            // 默认
            this.currentView = res.data.content[0].id;
            this.toggle();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
        // 精品课程列表
    async toggle(i, v) {
      if (i == undefined) {
        this.active = 0;
      } else {
        this.active = i;
        this.currentView = v;
      }
      var type_id = this.currentView;
      await this.$service.home
        .daily_appraisal_list({ type_id: type_id, page: 1, page_count: 4 })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.lists = res.data.content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 更多推荐
    async  appraisal_list(){
      await this.$service.home
        .appraisal_list({
          type_id: this.currentView,
          page: this.currentPage,
          page_count: this.pageSize
        })
        .then(res => {
          // console.log(res.data.content.list);
          if (res.data.code == 200) {
            this.g_lists = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查看更多
    goedetails(){
       this.$router.push({ path: "/evalu_more" });
    },
     // 跳转详情
    godetails(id) {
        this.$router.push({
          path: "/evalu_details",
          query: {
           id:id
          }
        });
    }
  },
  components: {
    Header,
    Footer,
    },
  mounted(){
    this.appraisal_type_list();  
    this.appraisal_list();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 导航 */
.Course1,
.Course {
  margin: 0 auto;
  width: 1200px;
  position: relative;
}
.Course1 .nav {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Course1 .nav .left {
  display: flex;
  align-items: center;
}
.Course1 ul {
  width: 800px;
  display: inline-flex;
  justify-content: space-around;
}
.Course1 .jingpin {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
}
.Course1 ul li {
  font-size: 16px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.Course1 ul li.active {
  color: #1775ef;
}
.Course1 .more {
  font-size: 16px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 59px;
}
/* 团图标 */
.Course .tuan {
  position: absolute;
  bottom: 361px;
  right: 5px;
}
.cont {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  /* justify-content: space-around; */
  flex-wrap: wrap;
  align-items: center;

}
.cont .list {
  width: 580px;
  height: 170px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.cont .list-cont {
  height: 130px;
  width: 530px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.cont .list-cont img {
  width: 240px;
  height: 134px;
  margin-right: 10px;
}
.cont .list-cont .right .name {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  letter-spacing: 1px;
  text-align: center;
}
.cont .list-cont .right .price {
  font-size: 24px;
  font-weight: 500;
  color: rgba(255, 67, 67, 1);
  line-height: 26px;
  margin-top: 58px;
  margin-left: 140px;
  text-align: right;
}
.cont .more {
  width: 1200px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  text-align: left;
  margin: 30px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cptx/evaluation.vue